<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <div class="container-fluid">
      <div class="p-2 border-bottom border-info">
        <h5 class="text-info font-italic">
          <strong><i class="fas fa-credit-card"></i> FeliCaカード登録</strong>
          <span class="ml-2">
            <b-btn size="md" variant="info" @click="refreshItems"><i class="fas fa-sync"/> 再読込</b-btn>
          </span>
        </h5>
      </div>
      <hr />
      <div v-if="!registeredList || registeredList.length < 1">
        <p>有効なFelicaカードは登録されていません。</p>
      </div>
      <div v-else>
        <p>登録済Felica</p>
        <b-list-group>
          <b-list-group-item v-for="(item, key, index) in registeredList" :key="index">
            <div v-if="idm(item.Key) != ''">
              <span><b>{{ item.idm }}</b>/</span>
              <span><b>{{ item.name }}</b></span>
              <span>{{ formatTime(item.LastModified) }}</span>
              <b-btn class="ml-2" variant="danger" @click="onDelete(item)">削除</b-btn>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
      <hr>
      <div v-if="!list || list.length < 1">
        <p>Felicaカードの登録を行うには、新規カードをかざしてください。</p>
      </div>
      <div v-else>
        <p>本日({{ today }})分 未登録Felica</p>
        <b-list-group>
          <b-list-group-item v-for="(item, key, index) in list" :key="index">
            <div v-if="idm(item.Key) != ''">
              <span>IDM: <b>{{ idm(item.Key) }}</b></span>
              <span>{{ formatTime(item.LastModified) }}</span>
              <b-btn class="ml-2" variant="success" @click="onRegister(item)" v-if="idm(item.Key) != ''">登録</b-btn>
              <b-btn class="ml-2" variant="danger" @click="onDelete(item)">削除</b-btn>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
    <div>
      <b-modal ref="registerModal" title="Felicaカード登録"
        header-bg-variant="info"
        header-text-variant="light"
        >
        <b-alert variant="danger" :show="registerError != null">{{registerError}}</b-alert>
        <form @submit.stop.prevent="onRegister">
          <b-form-group>
            IDM: <b>{{idm(currentItem.Key)}}</b>
          </b-form-group>
          <b-form-group>
            測定会: <b>({{currentUserGroup.groupId}}) {{currentUserGroup.name}}</b>
          </b-form-group>
          <b-form-group label="カード名:">
            <b-form-input
                        id="name"
                        type="text"
                        size="10"
                        v-model.trim="form.name"
                        :state="validators.name"
                        required
                        placeholder="わかりやすい名前をつけてください">
            </b-form-input>
          </b-form-group>
        </form>
        <div slot="modal-footer" class="w-100">
          <b-btn variant="success" @click="doRegister">
           登録
          </b-btn>
          <b-btn variant="link" @click="hideModal">
           閉じる
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AWS from 'aws-sdk'
import moment from 'moment-timezone'
import { Auth, Logger } from 'aws-amplify'
import AmplifyStore from '@/store/modules/AmplifyStore'

const logger = new Logger('felicaRegister')

export default {
  name: 'felicaRegister',
  data () {
    return {
      processing: false,
      message: null,
      error: null,
      registerError: null,
      registeredList: [],
      list: [],
      form: {
        name: null
      },
      validators: {
        name: null
      },
      currentItem: {},
      unregistered: {
        Key: ''
      }
    }
  },
  computed: {
    today () {
      return moment().tz('Asia/Tokyo').format('MM/DD')
    },
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    },
    userId () {
      return AmplifyStore.state.userId
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    formatTime (time) {
      return moment(time).format('MM/DD HH:mm:ss')
    },
    idm (key) {
      if (!key) {
        return ''
      }
      logger.debug(key)
      var match = key.match(/^public\/(.*)\/(.*)_(.*)\.json$/)
      if (match) { logger.info(match) }
      return (!match || match.length < 4) ? '' : match[2]
    },
    loadRegisteredItems () {
      this.$store.dispatch('fetchUserFelicas').then(list => {
        this.registeredList = list
      }).catch(err => {
        logger.error(err, err.stack)
        this.error = this.translateLocalMessage(err)
      })
    },
    loadItems () {
      this.error = null
      let date = moment.tz('Asia/Tokyo').format('YYYY/MM/DD')
      let prefix = 'public/unregistered/' + date + '/'

      Auth.currentCredentials()
        .then(credentials => {
          AWS.config.update({ region: 'ap-northeast-1' })

          let s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            credentials: Auth.essentialCredentials(credentials)
          })
          var params = { Bucket: process.env.VUE_APP_S3Bucket_Felica, Prefix: prefix }
          return s3.listObjectsV2(params).promise()
        }).then(data => {
          logger.info(data)
          if (data.Contents.length < 1) {
            this.message = '本日分の未登録のカードはありません。'
            this.list = []
            this.unregistered = {}
            return
          }
          this.list = data.Contents.filter(f => !f.Key.endsWith('/')).sort((a, b) => a.LastModified < b.LastModified)
          this.unregistered = this.list[0]
        }).catch(err => {
          logger.error(err, err.stack)
          this.error = this.translateLocalMessage(err)
        })
    },
    refreshItems () {
      this.message = null
      this.loadRegisteredItems()
      this.loadItems()
    },
    hideModal () {
      this.$refs.registerModal.hide()
    },
    onRegister (item) {
      if (!this.currentUserGroup) {
        this.error = '測定会を設定してください'
        return
      }
      this.currentItem = item
      this.form.name = null
      this.$refs.registerModal.show()
    },
    doRegister () {
      if (!this.currentUserGroup) {
        this.error = '測定会を設定してください'
        return
      }
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('createUserFelica', {
        userGroup: this.currentUserGroup,
        idm: this.idm(this.currentItem.Key),
        name: this.form.name || ''
      }).then(() => {
        this.loading = false
        this.message = '登録しました'
        return this.onDelete(this.currentItem)
      }).then(() => {
        this.$refs.registerModal.hide()
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        this.message = null
        logger.error(err)
        this.registerError = err.message || err
      })
    },
    onDelete (item) {
      return Auth.currentCredentials()
        .then(credentials => {
          AWS.config.update({ region: 'ap-northeast-1' })
          let s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            credentials: Auth.essentialCredentials(credentials)
          })
          var params = {
            Bucket: process.env.VUE_APP_S3Bucket_Felica,
            Key: item.Key
          }
          logger.debug(params)
          return s3.deleteObject(params).promise()
        }).then(data => {
          logger.info(data)
          this.loadItems()
        }).catch(err => {
          logger.error(err, err.stack)
          this.error = this.translateLocalMessage(err)
        })
    },
    translateLocalMessage (error) {
      return {
        'AccessDeniedException': '不正なアクセスです。再ログインしてください(S)',
        'ValidationException': '不正パラメタです。'
      }[error.code] || error.message
    }
  }
}
</script>

<style scoped>
</style>
